exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-19edf21c]:root {\n  --default-padding: 60px 0px 0px 0px;\n}\n@media screen and (max-width: 768px) {\n[data-v-19edf21c]:root {\n    --default-padding: 30px 0px 0px 0px;\n}\n}\n.VueCarousel-slide[data-v-19edf21c], .VueCarousel-slider-active[data-v-19edf21c] {\n  padding-right: 15px;\n  padding-left: 15px;\n  width: 1000px;\n}\n.previous-editions__card[data-v-19edf21c] {\n  background-size: cover;\n  background-position: center;\n  border-radius: 10px;\n  height: 400px;\n  width: 100%;\n}", ""]);

// exports
